export const color = {
  MossGreen: "#00CC83",
  Mint: "#53E0BD",
  white: "#FFF",
  Gray1: "#EEE",
  Gray2: "#ddd",
  Gray3: "#BBB",
  Gray4: "#888",
  Gray5: "#777",
  Gray6: "#454545",
  Black: "#1f211c",
  Black2: "#000",
  Gold: "#f0e68c",
}
